import classnames from 'classnames';
import isEqual from 'lodash/isEqual';
import noop from 'lodash/noop';
import { bool, func, number, oneOf } from 'prop-types';
import { Component } from 'react';

import WithWindowSize from '../WithWindowSize';

export default WithWindowSize()(
  class BetHeaderPopup extends Component {
    static propTypes = {
      visible: bool.isRequired,
      refHandler: func,
      windowWidth: number.isRequired,
      horizontalAlign: oneOf(['none', 'left', 'insetLeft']),
    };

    static defaultProps = {
      visible: false,
      refHandler: noop,
      horizontalAlign: 'insetLeft', // Align to parent left excluding border
    };

    state = {
      style: {},
    };

    componentDidUpdate(prevProps) {
      if (!prevProps.visible && this.props.visible) {
        this.ensureInsideViewport();
      }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.windowWidth !== this.props.windowWidth && this.node) {
        this.ensureInsideViewport();
      }
    }

    refHandler = ref => {
      this.props.refHandler(ref);
      this.node = ref;
      if (this.node) {
        this.ensureInsideViewport();
      }
    };

    ensureInsideViewport() {
      const { visible, horizontalAlign } = this.props;

      if (!visible) {
        return;
      }

      const vw = window.innerWidth || document.documentElement.clientWidth;

      const { left: parentLeft, width: parentWidth } =
        this.node.parentNode.getBoundingClientRect();

      const { width: nodeWidth } = this.node.getBoundingClientRect();

      const width = Math.min(
        vw,
        Math.max(
          nodeWidth,
          parentWidth + (horizontalAlign === 'insetLeft' ? -1 : 0),
        ),
      );

      const style = {
        left:
          horizontalAlign === 'none'
            ? undefined
            : parentLeft + (horizontalAlign === 'insetLeft' ? 1 : 0),
        width,
      };

      if (parentLeft + width > vw) {
        style.left = Math.max(0, vw - width);
      }

      style.maxHeight = this.getMaxHeight();

      if (!isEqual(style, this.state.style)) {
        this.setState({ style });
      }
    }

    getMaxHeight() {
      const elem = this.node;
      const rect = elem.getBoundingClientRect();
      const scrollTop = document.documentElement.scrollTop;
      const absoluteY = scrollTop + rect.top;
      const maxHeight = this.props.windowHeight - absoluteY - 15;

      return maxHeight;
    }

    render() {
      const { visible, className, children } = this.props;
      const { style } = this.state;

      return (
        <div
          ref={this.refHandler}
          className={classnames('bet-header-popup', className, {
            'bet-header-popup--visible': visible,
          })}
          style={style}
        >
          {children}
        </div>
      );
    }
  },
);
